import React from "react";
import { GiftCardTable } from "./GiftCardTable";

export const GiftCardManagement = (
    {
        match: {
            params: { userGroup },
        },
    }
) => {
    return (
        <div className="py-4 px-6">
            <GiftCardTable userGroup={userGroup} />
        </div>
    );
};
